'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.childEls = exports.allChildEls = undefined;

var _ramda = require('ramda');

var _childNodes = require('./childNodes');

var _nodeTypeTests = require('./nodeTypeTests');

var _nodeNames = require('./nodeNames');

var allChildEls = (0, _ramda.compose)((0, _ramda.filter)(_nodeTypeTests.isElement), _childNodes.allChildNodes);
var childEls = function childEls(localName, uri) {
    return (0, _ramda.compose)((0, _ramda.filter)((0, _nodeNames.hasName)(localName, uri)), allChildEls);
};

exports.allChildEls = allChildEls;
exports.childEls = childEls;